<div class="popup-header" role="dialog" aria-modal="true" aria-labelledby="budget-pdf-preview-title">
  <h2 id="budget-pdf-preview-title">{{ 'budget.pdf_preview.title' | translate }}</h2>
  <button type="button" class="close-button" (click)="cancel()"
    [attr.aria-label]="'common.cancel' | translate">
    <img src="assets/icons/close-modal.svg" alt="">
  </button>
</div>


<ngx-extended-pdf-viewer *ngIf="base64" [base64Src]="base64" height="80vh" [showToolbar]="!isWebView"
  [showSidebarButton]="false" [showFindButton]="false" [showPagingButtons]="!isWebView" [showZoomButtons]="!isWebView"
  [showPresentationModeButton]="false" [showOpenFileButton]="false" [showPrintButton]="!isWebView"
  [showDownloadButton]="!isWebView" [showSecondaryToolbarButton]="false" [showRotateButton]="false"
  [showHandToolButton]="false" [showScrollingButton]="false" [showSpreadButton]="false" [showPropertiesButton]="false"
  [minifiedJSLibraries]="true" [forceUsingLegacyES5]="true" [useInlineScripts]="true">
</ngx-extended-pdf-viewer>